import { ListItem } from '@mui/material';
import { NavLink } from 'react-router-dom';

import type { FC } from 'react';
import type { NavLinkProps } from 'react-router-dom';

interface ChildrenProps {
  isActive: boolean;
}

interface NavigationItemWrapperProps extends NavLinkProps {
  onActive?(): void;
  children: FC<ChildrenProps>;
}

export const NavigationItem: FC<NavigationItemWrapperProps> = ({
  to,
  children,
  className,
  onActive,
}) => (
  <ListItem disablePadding>
    <NavLink to={to} className={className} onClick={onActive}>
      {({ isActive }) => children({ isActive })}
    </NavLink>
  </ListItem>
);
